import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="266.718"
      height="1307.696"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 266.718 1307.696"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1272.603 -311.17)"
      >
        <path
          strokeWidth="5"
          d="M1298.4 620.661s17.4-14.34 20.51-41.841c3.11-27.502-8.33-68.461-8.33-68.461s4.92-.306 10.36-3.199c5.43-2.894 10.96-9.053 10.96-9.053s5.82 2.515 8.19 14.535c6.03 30.664-5.06 70.177 12.53 106.13 12.04 24.596 88.26 41.832 104.89 25.362 23.45-23.221-25.61-116.932-24.77-125.683.18-1.894 5.84 4.644 10.44 6.102 3.4 1.079 8.82 3.318 12.87 5.337 5.2 2.598 8.82 5.2 10.23 8.378 3.06 6.909 17.42 44.432 18.31 80.926.59 24.589 2.43 57.654 1.42 67.622-2.26 22.255-8.31 26.743-8.31 26.743s-3.84 2.952-6.45 8.552c-2.61 5.601-1.55 11.936-4.3 15.429-6 7.635-1.73 10.475-2.3 13.967"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1338.23 504.957l17.24-10.924"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1358.97 470.126l-4.72 38.116"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1350.92 423.385c-4.87 30.033 5.25 62.413 39.69 58.116"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1327.5 980.645s42.67 9.587 78.58 7.248c35.92-2.339 65.08-16.603 65.08-16.603s5.11-31.86 3.1-69.138c-1.38-25.581-5.37-52.61-7.84-70.48-1.75-12.706-.54-21.522-.54-21.522"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M1353.39 1291.92s12.4 1.35 23.78.97c9.28-.3 17.97-2.16 18.09-3.5 2.25-24.9 3.96-117.14 3.23-180.22-.41-35.35-3.18-61.57-3.18-61.57s13.04-20.67 17.4-26.61"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1383.22 1592.56s17.45-7.13 38.11-5.51c20.65 1.62 24.79 8.13 44.5 11.98 19.71 3.85 16.11-.32 30.87-.14 14.76.19 22.97 5.15 28.17.88"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1430.44 1593.25s19.99-5.59 35.73-7.89c15.74-2.3 27.21-1.31 27.21-1.31"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1288.31 510.813l21.98-.751"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1467.16 535.569s7.02-1.193 23.11-2.097c9.17-.515 12.15 3.719 23.27 11.045 4.53 2.988 7.83 4.588 12.15 12.742 2.26 4.28 3.97 9.928 4.71 14.374 3.24 19.367.63 35.917 2.44 78.521 1.15 27.267 2.62 55.359 2.84 85.149.09 12.379-2.39 25.983-4.15 36.26-2.08 12.096-1.64 19.211-5.23 26.78-3.55 7.499-12.6 15.068-18.05 16.066-8.73 1.596-21.24-2.459-36.19-5.577-1.54-.322-3.86.487-5.4.207-5.84-1.058-10.98-3.092-17.36-5.26-29.52-10.019-62.37-26.844-90.77-35.076-24.09-6.983-41.76-14.137-49.23-23.074-2.03-2.422-1.96-8.133-2.45-13.91-.78-9.137-1.31-18.82-1.31-18.82s-.1 1.164-1.4 2.002c-1.21.784-3.58 1.178-4.94 3.026-4.88 6.607-10 10.38-14.47 8.277-5.19-2.435-5.9-6.146-6.22-13.334-.25-5.534-6.14-11.689-5.33-18.814 1.79-15.756 4.76-24.5 14.9-31.632 2.82-1.979 8.83-4.314 11.54-3.164 3.52 1.494 6.32 7.278 10.21 9.118 5.48 2.588 12.98 1.67 17.14 7.416 9.39 12.979 5.52 26.656 14.58 41.155 9.07 14.499 10.58 12.527 21.68 16.842 17.15 6.667 44.19 9.858 66.97 13.623 15.52 2.566 36.3 7.805 44.74 3.443 5.02-2.596 5.21-40.583 5.21-40.583"
          opacity="1"
        ></path>
        <path
          strokeWidth="4"
          d="M1332.5 497.467s3.95-2.92 6.69-8.168c1.82-3.487 2.49-8.601 3.39-14.217 1.59-10.056 2.58-25.029 3.84-41.379.87-11.325 2.12-23.6 3.37-33.909 4.11-33.929 15.8-61.964 33.7-77.062 6.25-5.269 13.68-6.936 21.87-8.552 13.73-2.707 27.19.037 38.37 7.866 2.48 1.731 10.7 9.673 16.87 22.272 2.55 5.206 4.67 11.329 6.48 17.699 3.52 12.409 5.42 31.461 9.01 47.448 8.55 38.002 17.55 73.995 20.93 94.814 4.57 28.241 22.28 43.519 22.28 43.519"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1472.28 972.302c-2.07 26.674.26 56.348-1.67 94.538-1.34 26.66-9.79 78.81-14.2 105.35-2.74 16.53-4.51 28.3-4.57 29.89-.94 25.13-4.24 49.16-8.14 54.59-1.56 2.17-2.96 1.85-6.1 5.94-3.15 4.08-4.94 5.33-6.49 10.38-3.93 12.86-4.91 15.25-6.49 35.77-1.58 20.52.78 17.42-.26 44.4-1.05 26.98-1.63 27.78-3.93 63.52-1.41 21.93-4.77 47.85-2.69 70.84 1.18 13.08 2.59 24.57 4.78 36 1.42 7.45 2.5 15.87 6.34 21.26 6.34 8.9 30.48 22.32 35.78 25.18 12.26 6.61 28.75 11.89 41.73 17.6 10.76 4.74 23.72 12.02 29.68 16.87.57.46 3.35 7.56-6.94 10.29-4.64 1.23-12.41 1.5-22.65 1.62-30.74.38-38.18-3.29-47.38-6.19-12.13-3.82-34.7-2.59-55.19-1.31-10.77.67-24.79-1.41-24.79-1.41"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1395.43 1047.14s11.32-13.78 23.87-17.75c12.55-3.98 31.36-3.98 31.36-3.98"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M1396.51 1258.8s15.77 2.55 27.43 1.26c11.67-1.3 18.9-4.69 18.9-4.69"
          opacity="1"
        ></path>
        <path
          strokeDasharray="2"
          strokeWidth="1"
          d="M1396.9 1221.63s12.4 3.99 25.65 4.04c13.25.06 27.35-3.82 27.35-3.82"
          opacity="1"
        ></path>
        <path
          strokeDasharray="2"
          strokeWidth="1"
          d="M1349.7 1247.31s11.61 5.57 24.86 5.62c13.25.06 21.66-4.81 21.66-4.81"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1357.53 1331.83s9.05-4.69 16.55-12.96c7.5-8.26 13.45-20.1 13.45-20.1"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;